import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { invalidFieldContainerStyles } from '../common/questionWrappers';
import { EditDate } from './EditDate';
import { EditTime } from './EditTime';
export const EditDateTime = ({
  id,
  dateValue,
  timeValue,
  isInvalid,
  onDateChange,
  onTimeChange
}) => {
  return /*#__PURE__*/React.createElement(DateTimePickerContainer, {
    isInvalid: isInvalid
  }, /*#__PURE__*/React.createElement(EditDate, {
    id: id,
    value: dateValue,
    isInvalid: false,
    onChange: onDateChange
  }), /*#__PURE__*/React.createElement(EditTime, {
    id: id + '-time',
    value: timeValue,
    isInvalid: false,
    onChange: onTimeChange
  }));
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const DateTimePickerContainer = styled.div({
  display: 'flex',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '> div': {
    width: '50%'
  }
},
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
props => props.isInvalid && invalidFieldContainerStyles);